import axios from "axios";
import api from "@/services/api";

const blobCache = new Map<string, string>();

class ProfileImageService {

  async getImageBlobUrl(imageUrl: string | null | undefined): Promise<string> {
    if (!imageUrl) return '';

    if (blobCache.has(imageUrl)) {
      return blobCache.get(imageUrl)!;
    }

    try {
      const response = await axios.get(`${imageUrl}?t=${Date.now()}`, {
        responseType: 'blob'
      });

      const blobUrl = URL.createObjectURL(response.data);
      blobCache.set(imageUrl, blobUrl);

      return blobUrl;
    } catch {
      return '';
    }
  }

  async uploadProfileImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("profileImage", file);

    const response = await api.post("/api/users/profile/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data.profileImageUrl || response.data.imageUrl;
  }

  handleImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = "none";
  }

  clearCache(imageUrl?: string): void {
    if (imageUrl) {
      const filename = imageUrl.split("/").pop();
      if (filename) {
        const blobUrl = blobCache.get(filename);
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        blobCache.delete(filename);
      }
    } else {
      blobCache.forEach((blobUrl) => URL.revokeObjectURL(blobUrl));
      blobCache.clear();
    }
  }
}

export default new ProfileImageService();
